import { render, staticRenderFns } from "./Index-BoxFront.vue?vue&type=template&id=0ac23481"
import script from "./Index-BoxFront.vue?vue&type=script&lang=js"
export * from "./Index-BoxFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports